import React from 'react';
import Dropzone from 'react-dropzone';
import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";

import { sendMessageWebsocket, updateNewMessageFile } from "stores/actions";
import ChatService from "services/ChatService";
import AutomaticResponsesBtn from 'routes/app/components/Agent/AutomaticResponsesBtn';
import { IconButton } from "material-ui";
import MoreHorizIcon from "material-ui/svg-icons/navigation/more-horiz";

class SendMessage extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      message: false,
    };
  }

  sendTextMessage = () => {
    const { channelId, sendMessageWebsocket } = this.props;
    const { message } = this.state;
    if( message && message.trim() ) {
      sendMessageWebsocket( {
        message,
        channelId,
        date: new Date().valueOf()
      } );
      this.setState( { message: null } )
    }
  };

  sendFileMessage = ( file ) => {
    const { channelId, userId, updateNewMessageFile, userName, websocketChatToken } = this.props;

    const ref = uuidv4();
    const msg = {
      agent: { id: userId, name: userName },
      createdAt: moment().unix(),
      body: file.name,
      type: 'file',
      ref,
    };
    updateNewMessageFile( msg );
    this.setState( { message: null } )

    ChatService.sendFile( { file, channel: channelId, ref, chatToken: websocketChatToken } )
      .then( ( response ) => {
        if( response.errors ) {
          updateNewMessageFile( {
            ...msg,
            status: 'ERROR'
          } )
        }
      } )
  }

  render() {
    const { disabled, intl, websocketStatus, isOpened, responses } = this.props;
    const { message } = this.state;

    return (
      websocketStatus === 'on' && isOpened ?
        <div className="card-footer p-0" id="footer">
          <div className="row h-100 m-0">
            <div className="col-auto d-flex align-items-center px-0">
              <Dropzone
                className="dropzone pointer px-2 d-flex align-items-center"
                accept="image/*,.doc,.docx,.pdf"
                maxSize={1000000}
                onDrop={( files ) => {
                  if( files && files[0] ) {
                    const reader = new FileReader();
                    reader.onload = () => {
                      this.sendFileMessage( files[0] )
                    };
                    reader.readAsDataURL( files[0] );
                  }
                }}
              >
                <i className="icon-attachment text-info" style={{ fontSize: '18px' }}/>
              </Dropzone>
              <AutomaticResponsesBtn options={_.filter( responses, item => !item.type || item.type === 'chat' )}
                                     text={false}
                                     onClickResponse={( value ) => {
                                       this.setState( { message: value } )
                                     }}
                                     icon={(
                                       <IconButton touch tooltipPosition="bottom-left"
                                                   style={{ padding: 0, width: 30, height: 20 }}>
                                         <MoreHorizIcon color="#666666"/>
                                       </IconButton>
                                     )}
              />
            </div>
            <div className="col p-0">
          <textarea
            className="chat-send-message"
            value={message || ''}
            onChange={( val ) => this.setState( { message: val.target.value } )}
            placeholder={intl.formatMessage( { id: 'typeMessage' } )}
            onKeyDown={( e ) => {
              if( e.keyCode === 13 && e.shiftKey === false ) {
                e.preventDefault();
                this.sendTextMessage();
              }
            }}
          />
            </div>
            <div className="col-auto pl-0 d-flex align-items-center">
              <button
                className="btn btn-info btn-icon-only rounded-circle pointer"
                type="button"
                style={{ fontSize: '18px' }}
                disabled={disabled}
                onClick={this.sendTextMessage}
              >
                <i className="fa fa-paper-plane"/>
              </button>
            </div>
          </div>
        </div>
        : <span/>
    );
  }
}

const mapStateToProps = ( state ) => ( {
  userId: state.user.id,
  userName: state.user.name,
  websocketStatus: state.websocket.status,
  websocketChatToken: _.get( state.websocket, 'data.chatToken' ),
} );

const mapDispatchToProps = dispatch => ( {
  sendMessageWebsocket: ( data ) => {
    dispatch( sendMessageWebsocket( data ) );
  },
  updateNewMessageFile: ( data ) => {
    dispatch( updateNewMessageFile( data ) );
  },
} );


module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( SendMessage ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChatDetail/SendMessage/index.js